function PointerToolIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      fill="currentcolor"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M6.387 17.964a4 4 0 005.657 0c1.042-1.041 3.564-5.45 7.569-13.225-7.776 4.004-12.184 6.527-13.226 7.568a4 4 0 000 5.657z" />
    </svg>
  );
}

export default PointerToolIcon;
